
const SPU_LIST_UPDATE_LIST= 'SPU_LIST_UPDATE_LIST';
const SPU_LIST_UPDATE_CONDIION = 'SPU_LIST_UPDATE_CONDIION';
const SPU_LIST_UPDATE_PAGE = 'SPU_LIST_UPDATE_PAGE';
const SPU_LIST_UPDATE_MODALVALUE = 'SPU_LIST_UPDATE_MODALVALUE';
const SPU_LIST_UPDATE_ADDSKUVALUE = 'SPU_LIST_UPDATE_ADDSKUVALUE';


const SPUListModel = function() {
    const name = 'spu_list';
    return {
        name,
        state: {
          list: [],
          condition: {
            productName:'',
            categoryId:'',
            status:'',
            brandId:'',
          },
          modalValue:{
            isNew:true,
            id:'',
            productName:'',
            categoryId: '',
            brandId: '',
            productDetails:'',
            mobileDetails:'',
          },
          addSKUValue:{
            isNew:true,
            id:'',
            skuName:'',
            price: '',
            stock: '',
            spuNo:'',
            salesCount:'',
            validPeriod:'',
            periodUnit:'',
            productDate:'',
            expireDate:'',
            productDetails:'',
            mobileDetails:'',
          },
          page: {
              current: 1,
              total: 0,
              pageSize:30,
          },
        },
        selectors: (state) => {
            const currentState = state[name];
            const selectors = {
              getList: () => currentState.list,
              getCondition: () => currentState.condition,
              getPage: () => currentState.page,
              getModalValue: () => currentState.modalValue,
              getaddSKUValue: () => currentState.addSKUValue,
            };
            return selectors;
        },
        actions: {
          changeList: (list) => (dispatch, getState) => {
            dispatch({
                type: SPU_LIST_UPDATE_LIST,
                list
            });
          },
          changeCondition: (key, value) => (dispatch, getState) => {
              dispatch({
                  type: SPU_LIST_UPDATE_CONDIION,
                  key,
                  value
              });
          },
          changePage: (page) => (dispatch, getState) => {
                dispatch({
                    type: SPU_LIST_UPDATE_PAGE,
                    page
                });
            },
          changeModalValue: (key, value) => (dispatch, getState) => {
            dispatch({
                type: SPU_LIST_UPDATE_MODALVALUE,
                key, value
            });
          },
          changeAddSKUValue: (key, value) => (dispatch, getState) => {
            dispatch({
                type: SPU_LIST_UPDATE_ADDSKUVALUE,
                key, value
            });
          },
        },
        reducers: {
          list: (state=SPUListModel.state.list, action) => {
            if (action.type === SPU_LIST_UPDATE_LIST) {
              return [...action.list];
            }
            return state;
          },
          condition: (state=SPUListModel.state.condition, action) => {
                if (action.type === SPU_LIST_UPDATE_CONDIION) {
                  const { key, value } = action;
                  let obj = {};
                  obj[key] = value;
                  return Object.assign({}, state, obj);
                }
                return state;
          },
          page: (state=SPUListModel.state.page, action) => {
            if (action.type === SPU_LIST_UPDATE_PAGE) {
              return Object.assign({}, state, action.page);
            }
            return state;
          },
          modalValue: (state=SPUListModel.state.modalValue, action) => {
            if (action.type === SPU_LIST_UPDATE_MODALVALUE) {
              const { key, value } = action;
              let obj = {};
              obj[key] = value;
              return Object.assign({}, state, obj);
            }
            return state;
          },
          addSKUValue: (state=SPUListModel.state.addSKUValue, action) => {
            if (action.type === SPU_LIST_UPDATE_ADDSKUVALUE) {
              const { key, value } = action;
              let obj = {};
              obj[key] = value;
              return Object.assign({}, state, obj);
            }
            return state;
          },
        }
    };
}();

export default SPUListModel;


// WEBPACK FOOTER //
// ./src/models/SPUListModel.js